import {
  FormControls,
  SaveButton,
} from "../../../../components/flyer-detail-page-form/flyer-detail-page-form.styles";
import { TextField } from "../../../../../../../../../../features/forms/fields/text-field/text-field.component";
import React, { useRef } from "react";
import { withShowIf } from "../../../../../../../../../../components/with-show-if/with-show-If.component";
import { IFormRef } from "../../../../../../../../../../features/forms/types/forms.interface";
import { createFormRef } from "../../../../../../../../../../features/forms/types/forms.functions";
import { useControlForm } from "../../../../../../../../../../features/forms/forms.hook";
import { createFlyerDetailPageForm } from "../../types/flyer-detail-page-form.functions";
import { FlyerDetailPageFormPageViewProps } from "./flyer-detail-page-form-page-view.props";

export const FlyerDetailPageFormPageView = withShowIf((props: FlyerDetailPageFormPageViewProps) => {
  const formRef = useRef<Partial<IFormRef>>(createFormRef());

  const form = useControlForm({
    defaultValues: createFlyerDetailPageForm(props.page),
    formRef,
  });

  return (
    <FormControls>
      <TextField
        form={form}
        label="Notes"
        multiline
        name="notes"
        rows={3}
        userPermissions={props.permissions}
      />

      <TextField
        form={form}
        label="Theme"
        multiline
        name="theme"
        rows={5}
        userPermissions={props.permissions}
      />

      <SaveButton onClick={form.handleSubmit(props.onSave)}>Save</SaveButton>
    </FormControls>
  );
});
